import AutoComplete from "../Shared/AutosuggestV2/Autosuggestv2"
import { Urls } from "../../Urls";
import axios from "../../Axios";
import { toast } from "react-toastify";
import axios2 from "axios";
import { Row } from "../Shared/FlexDiv/FlexDiv";
import classes from "./FreightRates.module.css";
import FeedbackForm from "./BenchmarkMasterView/RatingsandFeedback";
import Modal from "./../Shared/PopupModal/PopupModal";
import Select from "react-select";

export const getKey = (origin, destination, trucktype) => {
  let key = `${origin}_${destination}_${trucktype}`;
  return key;
};

export const save_details_api = (payload) => {
  return axios.put(`${Urls.freight_master}?action=save_user_input`, payload);
};

export const next_page = (payload) => {
  return axios.put(`${Urls.freight_master}?action=update_excel_log`, payload);
};

export const isDuplicate = (data = [], key) => {
  return data.filter((item) => item.laneKey.trim() === key.trim()).length !== 0;
};

export const getUserDetails = async () => await axios.get(Urls.user_data);

export const getLocalDateTime = (dateString = "") => {
  return dateString
    ? `${new Date(dateString).toLocaleDateString()}_${new Date(
      dateString
    ).toLocaleTimeString()}`
    : `${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}`;
};

export const mailerAPI = (
  email_body,
  loader,
  success_message = "",
  error_message = ""
) => {
  axios
    .post(Urls.logURL, email_body)
    .then((res) => {
      if (loader) loader(false);
      if (success_message) toast.success(success_message);
    })
    .catch((err) => {
      if (loader) loader(false);
      if (error_message) toast.error(error_message);
    });
};

export const isQualitativeInputsEmpty = (input) => {
  if (!input) {
    return true;
  } else if (input) {
    if (
      !(
        input.benchmark_rating &&
        input.benchmark_rating.value &&
        input.benchmark_rating.value.hasOwnProperty("overall_rating")
      ) ||
      !(input.policy_terms && input.policy_terms.value) ||
      !(input.insurance && input.insurance.value)
    ) {
      return true;
    } else {
      return false;
    }
  }
};
export const SelectLane = ({
  userInput,
  handleChange,
  label,
  inputKey,
  valueKey,
  className,
}) => {
  return (
    <>
      <label className="mt-2" style={{ fontWeight: "100", fontSize: "15px" }}>{label}</label>
      <AutoComplete
        key={label}
        value={
          userInput[inputKey]
            ? { label: userInput[inputKey], value: userInput[inputKey] }
            : null
        }
        placeholder={label}
        className={"mb-3 my-2"}
        onChange={(val) => {
          handleChange(inputKey, val);
        }}
        onSelect={(obj) => {
          handleChange(valueKey, obj); // full object
          handleChange(inputKey, obj?.location_name || obj?.value || "");
        }}
      />
    </>
  );
};

export const Input = ({
  label = "",
  userInput,
  handleChange,
  valueKey,
  className = "",
  labelAvailable = true,
  tag = "text",
  type = "text",
  disabled = false,
  // rows = "3",
  options = [],
  height,
  // defaultSelected
}) => {
  const switcher = () => {
    switch (tag) {
      case "text":
        return (
          <input
            type={type}
            style={{ height: "36px" }}
            value={userInput[valueKey]}
            disabled={disabled}
            className={className}
            onChange={(e) => handleChange(valueKey, e.target.value)}
          />
        );
      case "textarea":
        return (
          <textarea
            value={userInput[valueKey]}
            onChange={(e) => handleChange(valueKey, e.target.value)}
            disabled={disabled}
            rows="2"
            style={{ minHeight: height === "sm" ? "10px" : "" }}
            cols="9"
          />
        );
      case "radio":
        return (
          <Row className={classes["justify-content-flex-start"]}>
            <label className="radio-inline">
              <input
                disabled={disabled}
                type="radio"
                onClick={(e) => handleChange(valueKey, e.target.value)}
                checked={userInput[valueKey] === "yes"}
                value="yes"
              ></input>
              YES
            </label>
            <label className="radio-inline">
              <input
                disabled={disabled}
                type="radio"
                onClick={(e) => handleChange(valueKey, e.target.value)}
                checked={userInput[valueKey] === "no"}
                value="no"
              ></input>
              NO
            </label>
          </Row>
        );
      case "select":
        return (
          <Select
            isMulti={false}
            options={options}
            isDisabled={disabled}
            className={"Truck_Type_Select"}
            classNamePrefix={"Truck_Prefix"}
            value={{ label: userInput[valueKey], value: userInput[valueKey] }}
            onChange={(e) => handleChange(valueKey, e.value)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {labelAvailable ? <label>{label}</label> : null}
      {switcher()}
    </>
  );
};
export const FileUploader = ({
  onChange,
  fileid,
  toggleLoader,
  supportedFiles = [],
  UnsupportedError,
}) => {
  const getWriteableUrl = async (file) => {
    return Promise.resolve(
      axios
        .get(
          `${Urls.fileUploadService
          }?action=upload&request_timestamp=${new Date().toISOString()}&id=BenchmarknowExcel&file_name=${file.name
          }`
        )
        .then((res) => {
          return res.data;
        })
        .catch((err) => "Error")
    );
  };
  const uploadFiletoBlob = (file, url, fileid) => {
    axios2
      .put(url, file, {
        headers: {
          "x-ms-blob-type": "blockblob",
          "x-ms-blob-content-disposition": file.name,
        },
      })
      .then((res) => {
        onChange(fileid, file.name);
      })
      .catch((err) => {
        toast.error("Failed to Upload");
      });
  };
  const validateFile = (file) => {
    if (file && file.size && file.size < 20 * 1024 * 1024) {
      return true;
    } else {
      toast.warn(`Please upload file below 20 MB`);
      return false;
    }
  };

  const onFileSelected = async (e) => {
    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      let ext = file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase();
      if (supportedFiles.includes(ext)) {
        if (validateFile(file)) {
          toggleLoader(true);
          getWriteableUrl(file).then((res) => {
            if (res !== "Error") {
              uploadFiletoBlob(file, res.url, res.fileid);
            }
          });
        }
      } else {
        toast.warn(UnsupportedError);
      }
    } else {
      toast.warn("Please Select File to Upload");
    }
  };
  return (
    <input
      type="file"
      id={fileid}
      onChange={(e) => onFileSelected(e)}
      style={{ display: "none" }}
    ></input>
  );
};

export const CommonModal = ({
  buttonLabel,
  notnc,
  company_id = "",
  isSuperAdmin = false,
  qualitativeInputs,
  setQualitativeInputs,
  dropDownSelect,
  getSessionDetails,
  id,
  toggleLoader,
  selectedOrg,
  setSelectedOrg,
  setOrgList,
  orgList,
  tncData,
  setUserData,
  onClose,
  title,
  closeButtonNeeded = true,
  saveButtonText,
  goToStart,
  disabled,
  buttonClass = "btn btn-primary",
  style,

}) => {
  return (
    <Modal
      screenName="Update Terms & Condition"
      moduleName="Update Terms & Condition"
      activityName="Update Terms & Condition Button Clicked"
      buttonLabel={buttonLabel}
      //disabled={disabled}
      buttonClass={buttonClass}
      id={id}
      content={
        <FeedbackForm
          qualitativeInputs={qualitativeInputs}
          selectedOrg={selectedOrg}
          dropDownSelect={dropDownSelect}
          setSelectedOrg={setSelectedOrg}
          orgList={orgList}
          setOrgList={setOrgList}
          tncData={tncData}
          setQualitativeInputs={setQualitativeInputs}
          getSessionDetails={getSessionDetails}
          goToStart={goToStart}
          company_id={company_id}
          isSuperAdmin={isSuperAdmin}
          notnc={notnc}
          toggleLoader={toggleLoader}
          setUserData={setUserData}
          saveButtonText={saveButtonText}
          onClose={onClose}
          buttonID="QualitativeFeedBackForm_Update"
          style={style}

        />
      }
      title={title}
      backdrop={false}
      style={style}
      size="md"

      disabled={disabled}
    />
  );
};
